import React from 'react';
import { connect } from 'react-redux';
import { logoutRequest } from './loginActions';
import { envConfig } from '../../config/config.js';
import { getCookieFromBrowser, removeCookie } from '../../commons/utils/cookie';
import axiosClient from '../../api/axiosClient';
import { setLoading } from '../../commons/components/application/miscActions';
import { withRouter } from 'react-router-dom';
import { clearCache } from '../../api/cacheManager';

class LogoutContainer extends React.Component {

    shouldComponentUpdate() {
        return !this.props.loggedIn;
    }

    handleLogout = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const v2ReturnUrl = urlParams.get('returnUrl');
        
        try {
            // Limpiar URL actual
            window.history.replaceState({}, '', '/');

            // 1. Logout del backend (v2)
            try {
                await axiosClient.post('/administrators/logout', {}, { withCredentials: true });
            } catch (err) {
                console.warn('Error en logout backend, continuando con limpieza local');
            }

            // 2. Limpieza de notificaciones y caché
            const OneSignal = window.OneSignal || [];
            OneSignal.push(() => OneSignal.removeExternalUserId());
            clearCache();

            // 3. Limpieza de estado local y credenciales
            this.props.logoutRequest();
            removeCookie("rememberMeUsernameCookie");
            removeCookie("auth_token");
            removeCookie("ray_auth");
            removeCookie("jwtCookie");
            axiosClient.defaults.headers.common['Authorization'] = "";
            localStorage.removeItem('persist:local');
            localStorage.removeItem('persist:session');
            localStorage.removeItem('auth_token');
            localStorage.removeItem('ray_auth');
            // 3. Redirigir según corresponda
            if (v2ReturnUrl) {
                window.location.href = decodeURIComponent(v2ReturnUrl);
                return;
            }
            
            // Si no viene de v2, ir a v2 para sincronizar
            // const returnUrl = encodeURIComponent(window.location.origin);
            // const v2LogoutUrl = `${envConfig.v2LogoutUrl}?returnUrl=${returnUrl}`;
            window.location.href = envConfig.v2LogoutUrl;
            
        } catch (error) {
            console.error('Error durante logout:', error);
            this.props.setLoading(false);
            this.props.history.push("/");
        }
    }

    componentDidMount() {
        this.props.setLoading(true);
        this.handleLogout();
    }

    render() {
        return null;
    }
}

const mapStateToProps = (state) => ({
    loggedIn: state.login.loggedIn,
    phpSession: getCookieFromBrowser("PHPSESSID")
});

export default withRouter(connect(mapStateToProps, { logoutRequest, setLoading })(LogoutContainer));



